import { render } from "./App.vue?vue&type=template&id=fab34058"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fab34058&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_szzsfxhtml5_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__